import { render, staticRenderFns } from "./ContactInformationStep.vue?vue&type=template&id=2c3013cc"
import script from "./ContactInformationStep.vue?vue&type=script&lang=js"
export * from "./ContactInformationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports